import React, { createContext, FC, useMemo } from 'react';
import { IComponentChildrenProps } from '@src/models/props';
import { IMenuContext, TMenuTheme } from './models';

export const MenuContext = createContext<IMenuContext>({
  theme: 'white',
});

interface IMenuProviderProps extends IComponentChildrenProps {
  theme?: TMenuTheme;
}

export const MenuProvider: FC<IMenuProviderProps> = ({ theme = 'white', children }) => {
  const value = useMemo<IMenuContext>(
    () => ({
      theme,
    }),
    [theme],
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
